import * as yup from 'yup'
const schema = yup.object().shape({
  abortEarly: false,
  email: yup.string().email('Esse não é um e-mail valido').required('Esse é um campo requerido'),
})

export default schema
